import dynamic from 'next/dynamic'

const InputWrapper = dynamic(() => import('root/src/client/web/form/InputWrapper'))
const TextField = dynamic(() => import('root/src/client/web/form/TextField'))
const AmountNumber = dynamic(() => import('root/src/client/web/form/AmountNumber'))
const AutoComplete = dynamic(() => import('root/src/client/web/form/AutoComplete'))
const AttachmentInput = dynamic(() => import('root/src/client/web/form/AttachmentInput'))
const ImageInput = dynamic(() => import('root/src/client/web/form/ImageInput'))
const TimeStampInput = dynamic(() => import('root/src/client/web/form/TimeStampInput'))
const Dropdown = dynamic(() => import('root/src/client/web/form/Dropdown'))
const InitialProductInput = dynamic(() => import('root/src/client/web/form/InitialProductInput'))
const VariantField = dynamic(() => import('root/src/client/web/form/VariantField'))
const MultiWay = dynamic(() => import('root/src/client/web/form/MultiWay'))
const RadioInput = dynamic(() => import('root/src/client/web/form/RadioInput'))
const RadioCardInput = dynamic(() => import('root/src/client/web/form/RadioCardInput'))
const Checkbox = dynamic(() => import('root/src/client/web/form/Checkbox'))
const DateTime = dynamic(() => import('root/src/client/web/form/DateTime'))
const BreakpointInput = dynamic(() => import('root/src/client/web/form/BreakpointInput'))
const TextArea = dynamic(() => import('root/src/client/web/form/MuiTextArea'))

export const Field = ({ props, wrapperProps, inputType }) => {
	switch (inputType) {
	case 'text':
	case 'email':
	case 'registerEmail':
	case 'password':
	case 'number':
	case 'nonNegativeNumber':
	case 'textWithToggle':
		return (
			<InputWrapper {...wrapperProps}>
				<TextField {...props} />
			</InputWrapper>
		)
	case 'amountNumber':
		return (
			<InputWrapper {...wrapperProps}>
				<AmountNumber {...props} />
			</InputWrapper>
		)
	case 'autoComplete':
		return (
			<InputWrapper {...wrapperProps}>
				<AutoComplete {...props} />
			</InputWrapper>
		)
	case 'attachmentInput':
		return (
			<InputWrapper {...wrapperProps}>
				<AttachmentInput {...props} />
			</InputWrapper>
		)
	case 'imageInput':
		return (
			<InputWrapper {...wrapperProps}>
				<ImageInput {...props} />
			</InputWrapper>
		)
	case 'timeStamp':
		return (
			<InputWrapper {...wrapperProps}>
				<TimeStampInput {...props} />
			</InputWrapper>
		)
	case 'dropdown':
		return (
			<InputWrapper {...wrapperProps}>
				<Dropdown {...props} />
			</InputWrapper>
		)
	case 'initialProduct':
		return (
			<InputWrapper {...wrapperProps}>
				<InitialProductInput {...props} />
			</InputWrapper>
		)
	case 'variantField':
		return (
			<InputWrapper {...wrapperProps}>
				<VariantField {...props} />
			</InputWrapper>
		)
	case 'multiWay':
		return (
			<InputWrapper {...wrapperProps}>
				<MultiWay {...props} />
			</InputWrapper>
		)
	case 'radio':
		return (
			<InputWrapper {...wrapperProps}>
				<RadioInput {...props} />
			</InputWrapper>
		)
	case 'radioCard':
		return (
			<InputWrapper {...wrapperProps}>
				<RadioCardInput {...props} />
			</InputWrapper>
		)
	case 'checkbox':
		return (
			<InputWrapper {...wrapperProps}>
				<Checkbox {...props} />
			</InputWrapper>
		)
	case 'date':
		return (
			<InputWrapper {...wrapperProps}>
				<DateTime {...props} />
			</InputWrapper>
		)
	case 'breakpointInput':
		return (
			<InputWrapper {...wrapperProps}>
				<BreakpointInput {...props} />
			</InputWrapper>
		)
	case 'textarea':
		return (
			<InputWrapper {...wrapperProps}>
				<TextArea {...props} />
			</InputWrapper>
		)
	case null:
		return null
	default:
		return (
			<div>
				<p>inputType: {inputType}</p>
			</div>
		)
	}
}
